import { Head, router } from "@inertiajs/react"
import { AppLayout } from "@/layouts/app-layout"
import { PageHeader } from "@/hooks/use-page-header"
import { usePluExtractionChannel } from "@/hooks/use-plu-extraction-channel"
import { CommuneInfoCard } from "./commune-info-card"
import { PluExtractionCard } from "./plu-extraction-card"
import { PluZonesTable } from "./plu-zones-table"
import type { Commune, PluExtractionRun, PluZone } from "@/types"

type Props = {
  commune: Commune
  latest_run: PluExtractionRun | null
  plu_zones: PluZone[]
}

function CommuneShow({ commune, latest_run, plu_zones }: Props) {
  const cableUpdate = usePluExtractionChannel({
    communeId: commune.id,
    onComplete: () => {
      setTimeout(() => router.reload(), 500)
    },
  })

  const effectiveStatus = cableUpdate?.status ?? latest_run?.status ?? null
  const isInProgress = commune.plu_extraction_status === "in_progress" || cableUpdate?.type === "step_update"
  const stepTimings = cableUpdate?.step_timings ?? latest_run?.step_timings ?? {}

  function handleExtract() {
    router.post(`/communes/${commune.id}/extract_plu`)
  }

  return (
    <>
      <Head title={commune.name} />
      <PageHeader title={commune.name} back="/communes" backLabel="Communes" />
      <div className="space-y-6">
        <CommuneInfoCard commune={commune} />
        <PluExtractionCard
          status={commune.plu_extraction_status}
          run={latest_run}
          zones={plu_zones}
          cableUpdate={cableUpdate}
          isInProgress={isInProgress}
          effectiveStatus={effectiveStatus}
          stepTimings={stepTimings}
          onExtract={handleExtract}
        />
        <PluZonesTable zones={plu_zones} />
      </div>
    </>
  )
}

CommuneShow.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>

export default CommuneShow
